import { render, staticRenderFns } from "./Admin-Layout.vue?vue&type=template&id=f9c94e7c&"
import script from "./Admin-Layout.vue?vue&type=script&lang=js&"
export * from "./Admin-Layout.vue?vue&type=script&lang=js&"
import style0 from "./Admin-Layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports